import Splide from '@splidejs/splide-4';

import { _isOnScreen, _once } from '../../utils';

_isOnScreen(
  '.splide-topWriters',
  _once(() => {
    new Splide('.splide-topWriters', {
      label: 'Top Writers',
      type: 'slide',
      pagination: false,
      arrows: true,
      perPage: 1,
      gap: 24,
      mediaQuery: 'min',
      breakpoints: {
        1280: {
          perPage: 3,
          gap: 16,
        },
        640: {
          perPage: 2,
        },
      },
    }).mount();
  }),
);

_isOnScreen(
  '.chat',
  _once(() => {
    const messages = document.querySelectorAll('.chat__message');
    messages.forEach(message => {
      message.classList.add('chat__animation');
    });
  }),
);
